import ScrollTrigger from '@terwanerik/scrolltrigger'

export function onScroll() {
	const fade = new ScrollTrigger({
		trigger: {
			once: true,

			offset: {
				element: {
					x: 0,
					y: 0.4,
				},
			},

			toggle: {
				class: {
					in: 'fade-in',
				},
			},
		},
	})

	const trigger = new ScrollTrigger({
		trigger: {
			once: false,

			offset: {
				viewport: {
					x: 0,
					y: 0.5,
				},
			},

			toggle: {
				class: {
					in: 'hover',
					out: 'no-hover',
				},
			},
		},
	})

	trigger.add('[data-trigger]')
	trigger.add('[data-trigger-once]', { once: true })
	fade.add('[data-fade-in]')
	// removes fade-in from slider elements because is breaks them on mobile
	document.querySelectorAll('.splide__slide:not(.is-visible) [data-fade-in]').forEach((item) => {
		item.removeAttribute('data-fade-in')
		item.classList.add('faded-in')
	})
}
